export default "__VITE_ASSET__CPVadvXn__"